import React, { useState } from 'react';

const extractYouTubeId = input => {
  if (!input) return null;
  // if a full url, try to extract
  try {
    const u = input;
    // if it's already an id with params like 'id&t=4s'
    if (
      !u.includes('http') &&
      !u.includes('youtube') &&
      !u.includes('youtu.be')
    ) {
      return u.split('&')[0];
    }
    const url = new URL(u);
    if (url.hostname.includes('youtu.be')) return url.pathname.slice(1);
    if (
      url.hostname.includes('youtube') ||
      url.hostname.includes('www.youtube')
    ) {
      return url.searchParams.get('v') || null;
    }
  } catch (e) {
    return input.split('&')[0];
  }
  return null;
};

const isVimeo = src => /vimeo.com/.test(src);

export default function VideoPlayer({
  src,
  thumbnail,
  poster,
  title,
  className,
}) {
  const [open, setOpen] = useState(false);

  const ytId = extractYouTubeId(src);
  const embedSrc = ytId
    ? `https://www.youtube.com/embed/${ytId}?autoplay=1&rel=0`
    : isVimeo(src)
      ? src.replace(/vimeo.com\/(video\/)?/, 'player.vimeo.com/video/') +
        '?autoplay=1'
      : src;

  const thumb =
    thumbnail ||
    (ytId
      ? `https://i.ytimg.com/vi/${ytId}/hqdefault.jpg`
      : poster || '/images/video-placeholder.jpg');

  return (
    <div className={`video-player ${className || ''}`}>
      <div
        role="button"
        tabIndex={0}
        className="relative cursor-pointer bg-black overflow-hidden rounded-md"
        onClick={() => setOpen(true)}
        onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && setOpen(true)}
      >
        <img
          src={thumb}
          alt={title || 'video thumbnail'}
          className="w-full h-56 object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="bg-black bg-opacity-50 p-4 rounded-full">
            <svg
              className="w-10 h-10 text-white"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </div>
        </div>
      </div>

      {open && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-95 flex items-center justify-center p-4">
          <button
            onClick={() => setOpen(false)}
            className="absolute top-6 right-6 text-white hover:text-gray-300 z-50"
            aria-label="Close video"
          >
            ✕
          </button>

          <div className="w-full max-w-4xl">
            {ytId || isVimeo(src) ? (
              <iframe
                title={title || 'video'}
                src={embedSrc}
                allow="autoplay; encrypted-media"
                allowFullScreen
                className="w-full h-[56vw] max-h-[70vh]"
              />
            ) : (
              <video
                controls
                autoPlay
                playsInline
                poster={poster}
                className="w-full h-auto max-h-[80vh]"
                aria-label={title || 'video'}
              >
                <source src={embedSrc} />
                <track kind="captions" />
                Your browser does not support the video tag.
              </video>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
